module.exports = "<ota-dialog class=\"dialog-cancellation-policy\" [disbledClose]=\"true\" [closeBottom]=\"true\">\n  <div id=\"levelD-div-cancellation-box\" class=\"cancellation-box\">\n    <p id=\"levelD-text-cancellation-policy-description-{{i}}\" *ngFor=\"let cancellation of cancellations; let i=index;\">{{cancellation}}</p>\n  </div>\n</ota-dialog>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-cancellation/dialog-cancellation.component.html
// module id = 1044
// module chunks = 22